import React, { useCallback, useRef } from "react";
import { Row, Col, Flex, Typography, Button, App, Divider } from "antd";
import { Paragraph, Document, Packer, TextRun, ShadingType } from "docx";
import { useSelector } from "react-redux";
import { bailiffDialogOptionSpeakerSelector } from "store/bailiff/bailiff/dialog/bailiff_dialog.selector";
import { BsSoundwave } from "react-icons/bs";
import { MdReplay } from "react-icons/md";
//
//component
import CardBailiffDialog from "component/cards/bailiff/card_bailiff_dialog";
//redux
//selector
import { bailiffDocumentDetailSelector } from "store/bailiff/bailiff/document/bailiff_document.selector";
//actions
//utils
//hook
//str
import empty from "asset/img/placeholder/empty_folder.webp";
import { saveAs } from "file-saver";
import { useResponsive } from "hook/useResponsive";
import { useFlow, FLOWS } from "hook/bailiff/document/flow/useFlow";
import { refineSpecificTimer } from "util/refine_timer.function";
import { COLORS_SPEAKER } from "store/string";
import { useBailiffDownload } from "hook/bailiff/document/action/useBailiffDownload";
import { DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import { useActionDraftMergeRefine } from "hook/bailiff/dialog/useActionDialogMerge";

const BailiffLayout = () => {
  // -------------------------- VAR -----------------------------
  const { data } = useActionDraftMergeRefine();
  const { message } = App?.useApp();
  const {
    loading,
    handleDownload,
    loadingDelete,
    handleCancelDelete,
    loadingCancel,
    handleForceDelete,
  } = useBailiffDownload();
  const docRef = useRef(null);
  const { flow } = useFlow();
  const { mobile } = useResponsive();
  const padding = mobile ? "20px 20px" : "20px 40px";
  const isPaid = flow === FLOWS.PAID;

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(bailiffDocumentDetailSelector);
  const options = useSelector(bailiffDialogOptionSpeakerSelector);

  const name = detail?.name;
  const downloadedAt = detail?.downloadedAt;
  const id = detail?.id;
  const status = detail?.status;
  const isDelete = status === "deleting";

  // -------------------------- FUNCTION ------------------------
  const handleGenerate = () => {
    if (isDelete)
      return message.error(
        "File đã bị xoá tạm thời. Nếu bạn muốn tải về, xin huỷ tác vụ",
      );

    if (downloadedAt) {
      return generateDocx();
    } else {
      return handleDownload({ id, generateDocx });
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const generateDocx = useCallback(async () => {
    const children = renderChildren(data, options);
    const doc = new Document({
      sections: [
        {
          children: children,
        },
      ],
    });

    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, `${name}.docx`);
      console.log("Document created successfully");
    });
  });
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // thao tác.
  // const renderAction = () => {
  //   return (
  //     <Row style={{ marginTop: 40 }}>
  //       <Col align="center" xl={24} lg={24} md={24} xs={24}>
  //         <div className="flex flex-col items-center justify-center gap-2 md:flex-row">
  //           {renderDownload()}
  //           {renderForce()}
  //           {renderDelete()}
  //         </div>
  //       </Col>
  //     </Row>
  //   );
  // };

  const renderDownload = () => {
    if (isDelete) return null;
    return (
      <Button
        icon={<DownloadOutlined />}
        loading={loading}
        disabled={isDelete}
        onClick={handleGenerate}
      >
        <div>Tải về</div>
      </Button>
    );
  };

  const renderForce = () => {
    if (isDelete) return null;
    return (
      <Button
        loading={loadingDelete}
        disabled={isDelete}
        onClick={() => handleForceDelete({ id })}
        danger
        icon={<DeleteOutlined />}
      >
        <div>Xoá</div>
      </Button>
    );
  };

  const renderDelete = () => {
    if (!isDelete) return null;
    return (
      <Button
        loading={loadingCancel}
        disabled={!isDelete}
        onClick={() => handleCancelDelete({ id })}
        icon={<MdReplay />}
      >
        <div>Khôi Phục</div>
      </Button>
    );
  };

  // nếu empty.
  const renderEmpty = () => {
    if (data?.length === 0) {
      const size = 100;
      return (
        <Row
          style={{
            minHeight: 300,
            width: "100%",
            border: "2px dashed rgba(159, 159, 159, 0.2)",
            margin: "120px 0px 100px",
          }}
        >
          <Flex
            style={{ width: "100%", minHeight: "100%" }}
            align="center"
            justify="center"
          >
            <Row gutter={[30, 10]} justify={"center"}>
              <Col align="center" xl={24} lg={24} md={24} xs={24}>
                <img
                  style={{ width: size, height: size }}
                  src={empty}
                  alt="doc"
                />
              </Col>
              <Col align="center" xl={24} lg={24} md={24} xs={24}>
                <Typography.Text type="secondary">
                  File Không tìm thấy. Xin vui lòng liên hệ quản trị viên để
                  được hỗ trợ
                </Typography.Text>
              </Col>
            </Row>
          </Flex>
        </Row>
      );
    }
  };

  const renderLists = () => {
    if (data?.length > 0) {
      return (
        <div
          className="flex flex-col shadow-sm"
          style={{
            margin: "40px 0px 100px",
            background: "#fff",
            minHeight: "100vh",
            borderRadius: 2,
            padding,
          }}
        >
          <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
            <div>
              <Typography.Title
                level={4}
                style={{ margin: 0 }}
                ellipsis={{ rows: 1 }}
                className="flex flex-row items-center gap-1"
              >
                <BsSoundwave size={20} />
                Văn bản biên dịch
              </Typography.Title>
            </div>
            <div className="flex flex-row items-center justify-end gap-2">
              {renderDownload()}
              {renderForce()}
              {renderDelete()}
            </div>
          </div>
          <Divider dashed className="my-4" />
          <div>
            <Row ref={docRef}>
              {data?.map((item, index) => {
                const first = index === 0;
                return (
                  <Col key={index} span={24}>
                    {!first && <Divider dashed className="my-4" />}
                    <CardBailiffDialog data={item} order={index} />
                  </Col>
                );
              })}
            </Row>
          </div>
          <div className="mt-10 flex flex-row items-center justify-center text-[10px] text-gray-400">
            <Divider plain className="my-0 !text-gray-300">
              END
            </Divider>
          </div>
        </div>
      );
    }
  };
  // -------------------------- MAIN ----------------------------

  if (!isPaid) return null;
  return (
    <>
      {renderLists()}
      {renderEmpty()}
    </>
  );
};
export default BailiffLayout;

const renderChildren = (data, options) => {
  const children = [];

  data?.forEach((item) => {
    const speaker = item?.fixSpeaker || item?.speaker || "";
    const from = item?.fixFrom || item?.from || 0;
    const to = item?.fixTo || item?.to || 0;
    const labelForm = refineSpecificTimer({ timer: from });
    const labelTo = refineSpecificTimer({ timer: to });
    const duration = `${labelForm} → ${labelTo}`;
    const text = item?.fix || item?.text || "";
    const labelSpeaker = `Người nói thứ ${speaker}`;
    const labelDuration = `${duration}`;
    const labelContent = `${text}`;
    const number = options?.findIndex((o) => o === speaker) || 0;
    const color = COLORS_SPEAKER?.[number] || "#f2f2f2";
    const upper = color?.replace("#", "")?.toUpperCase();

    const text1 = new Paragraph({
      children: [
        new TextRun({
          text: labelSpeaker,
          bold: true,
          shading: {
            type: ShadingType.PERCENT_15,
            color: "FFFFFF",
            fill: upper,
          },
        }),
      ],
    });
    const text2 = new Paragraph({
      children: [
        new TextRun({
          text: labelDuration,
          color: "#aeaeae",
        }),
      ],
    });

    const text3 = new Paragraph({
      children: [
        new TextRun({
          text: labelContent,
        }),
      ],
      spacing: {
        line: 500, // Giá trị 360 tương đương với 1.5 line height nếu font size 12pt (12pt * 20 = 240, 1.5 x 240 = 360)
        lineRule: "exact", // Hoặc "auto", "atLeast" tùy theo nhu cầu
      },
    });
    const gap = new Paragraph({ text: "" });
    children.push(text1);
    children.push(text2);
    children.push(text3);
    children.push(gap);
  });

  return children;
};
